'use strict';

// Product page behaviour (WI-30): the reference-image thumbnail swap and the
// persistent Request a Quote in the header.
//
// The header is the page's one persistent bar (sections/dha-header.liquid
// renders a hidden quote button + product identity on product templates).
// This script fills them from the product section's own primary action and
// shows them only while neither the in-page primary action nor the closing
// action is on screen — so the quote is never offered twice at once and no
// second sticky bar exists. The button is a normal [data-dha-quote-trigger],
// so the existing quote modal opens unchanged.

(function () {
  function initThumbs(root) {
    var hero = root.querySelector('[data-dha-prod-hero]');
    var thumbs = root.querySelectorAll('[data-dha-prod-thumbs] .dha-prod__thumb');
    if (!hero || !thumbs.length) return;
    var plate = hero.parentNode;
    var pending = 0;

    // The viewer follows the selected image's own ratio. The new image is
    // loaded first and the ratio + src change together, so the old image is
    // never stretched into the new frame.
    function show(thumb) {
      var src = thumb.getAttribute('data-full');
      var w = parseFloat(thumb.getAttribute('data-width'));
      var h = parseFloat(thumb.getAttribute('data-height'));
      var token = ++pending;
      var probe = new Image();
      function apply() {
        if (token !== pending) return;
        var ratio = w > 0 && h > 0 ? w / h : probe.naturalWidth / probe.naturalHeight;
        if (ratio > 0 && isFinite(ratio)) {
          plate.style.setProperty('--dha-media-ar', ratio.toFixed(4));
          hero.height = Math.round(hero.width / ratio);
        }
        hero.src = src;
      }
      probe.onload = apply;
      probe.onerror = apply;
      probe.src = src;
    }

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb);
        Array.prototype.forEach.call(thumbs, function (t) {
          t.classList.remove('dha-prod__thumb--active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('dha-prod__thumb--active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function initPin(root) {
    var primary = root.querySelector('[data-dha-primary-cta]');
    var closing = document.querySelector('[data-dha-closing-cta]');
    var pinQuote = document.querySelector('[data-dha-pin-quote]');
    var pinId = document.querySelector('[data-dha-pin-top]');
    if (!primary || !pinQuote) return;

    var buy = root.querySelector('[data-dha-prod-buy]');
    var quoteButton = primary.querySelector('[data-dha-quote-trigger]');
    if (quoteButton && quoteButton.textContent.trim()) pinQuote.textContent = quoteButton.textContent.trim();
    pinQuote.hidden = false;

    if (pinId && buy) {
      var code = buy.getAttribute('data-pin-code') || '';
      var price = buy.getAttribute('data-pin-price') || '';
      pinId.querySelector('[data-dha-pin-code]').textContent = code;
      pinId.querySelector('[data-dha-pin-price]').textContent = price ? 'from ' + price : '';
      pinId.hidden = !code;
      pinId.addEventListener('click', function (event) {
        event.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
    }

    // The rule is purely "is a quote button already on screen?": the header
    // offers one exactly when neither the in-page primary action nor the
    // closing action is visible. (No scroll-depth test: this theme scrolls
    // inside a wrapper, not the window, and on phones the in-page action starts
    // below the fold, where the header should offer the quote from the start.)
    var visible = { primary: true, closing: false };

    function apply() {
      var pinned = !visible.primary && !visible.closing;
      document.body.classList.toggle('dha-quote-pinned', pinned);
      if (pinId) pinId.tabIndex = pinned ? 0 : -1;
    }

    function headerHeight() {
      var header = document.querySelector('.dha-header');
      return header ? Math.ceil(header.getBoundingClientRect().height) : 90;
    }

    var observer = null;
    function observe() {
      if (observer) observer.disconnect();
      if (typeof IntersectionObserver !== 'function') return false;
      // Anything under the fixed header counts as not visible.
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === primary) visible.primary = entry.isIntersecting;
          else visible.closing = entry.isIntersecting;
        });
        apply();
      }, { rootMargin: '-' + headerHeight() + 'px 0px 0px 0px', threshold: 0 });
      observer.observe(primary);
      if (closing) observer.observe(closing);
      return true;
    }

    if (!observe()) {
      var measure = function () {
        var top = headerHeight();
        var seen = function (node) {
          if (!node) return false;
          var r = node.getBoundingClientRect();
          return r.bottom > top && r.top < window.innerHeight;
        };
        visible.primary = seen(primary);
        visible.closing = seen(closing);
        apply();
      };
      // Capture: scroll events from an inner scroll container don't bubble.
      document.addEventListener('scroll', measure, { passive: true, capture: true });
      window.addEventListener('resize', measure);
      measure();
    } else {
      window.addEventListener('resize', observe);
    }
  }

  function init() {
    var root = document.querySelector('[data-dha-product]');
    if (!root) return;
    initThumbs(root);
    initPin(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
